import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AgmCoreModule } from '@agm/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from '../shared/shared.module';
import { Ng9RutModule } from 'ng9-rut';
import { ReportesModule } from './reportes/reportes.module';
import { AccionesComercialesModule } from './acciones-comerciales/acciones-comerciales.module';
import { InventarioModule } from './inventario/inventario.module';
import { VentasModule } from './ventas/ventas.module';
import { CtaCteClienteModule } from './cta-cte-cliente/cta-cte-cliente.module';
import { CtaCteProveedoresModule } from './cta-cte-proveedor/cta-cte-proveedores.module';
import { FinanzasModule } from './finanzas/finanzas.module';
import { MaquinasModule } from './maquinas/maquinas.module';
import { MantenedoresModule } from './mantenedores/mantenedores.module';
import { ComprasModule } from './compras/compras.module';
import { ConfiguracionSistemaModule } from './configuracion-sistema/configuracion-sistema.module';
import { FacturacionMasivaModule } from './facturacion-masiva/facturacion-masiva.module';
import { LiquidacionRecorridosModule } from './liquidacion-recorridos/liquidacion-recorridos.module';
import { AnalisisEventosModule } from './analisis-eventos/analisis-eventos.module';
import { FooterComponent } from '../main-layout/footer/footer.component';
import { BasicTableComponent } from './tables/basic-table/basic-table.component';
import { ModalsComponent } from './modals/modals.component';
import { TypographyComponent } from './css/typography/typography.component';
import { IconsComponent } from './css/icons/icons.component';
import { Map1Component } from './maps/map1/map1.component';
import { StatsCardComponent } from './dashboards/common/stats-card/stats-card.component';
import { StatsCard2Component } from './dashboards/common/stats-card2/stats-card2.component';
import { Dashboard1Component } from './dashboards/dashboard1/dashboard1.component';
import { GridComponent } from './css/grid/grid.component';
import { MediaObjectComponent } from './css/media-object/media-object.component';
import { UtilitiesComponent } from './css/utilities/utilities.component';
import { ImagesComponent } from './css/images/images.component';
import { ColorsComponent } from './css/colors/colors.component';
import { ShadowComponent } from './css/shadow/shadow.component';
import { Profile1Component } from './profile/profile1/profile1.component';
import { HelpComponent } from './help/help.component';
import { VendedorComponent } from './vendedor/vendedor.component';
import { TerritorioComponent } from './territorio/territorio.component';
import { BancoComponent } from './banco/banco.component';
import { BodegaComponent } from './bodega/bodega.component';
import { ZonaComponent } from './zona/zona.component';
import { TipoclieComponent } from './tipoclie/tipoclie.component';
import { RutaComponent } from './ruta/ruta.component';
import { CondipagComponent } from './condipag/condipag.component';
import { CobradorComponent } from './cobrador/cobrador.component';
import { LoginComponent } from './login/login.component';
import { NotificacionesComponent } from './notificaciones/notificaciones.component';
import { TipoCuentaComponent } from './tipo-cuenta/tipo-cuenta.component';
import { ClientesComponent } from './clientes/clientes.component';
import { MantenedorClientesModalResumenComponent } from './clientes/modal-resumen/modal-resumen.component';
import { MantenedorClientesModalDatosFinancierosComponent } from './clientes/modal-datos-financieros/modal-datos-financieros.component';
import { MantenedorClientesModalDatosComercialesComponent } from './clientes/modal-datos-comerciales/modal-datos-comerciales.component';
import { MantenedorClientesModalDireccionesComponent } from './clientes/modal-direcciones/modal-direcciones.component';
import { MantenedorClientesModalDatosPersonalesComponent } from './clientes/modal-datos-personales/modal-datos-personales.component';
import { FormDatosFinancierosComponent } from './clientes/form-datos-financieros/form-datos-financieros.component';
import { FormDatosComercialesComponent } from './clientes/form-datos-comerciales/form-datos-comerciales.component';
import { FormDatosPersonalesComponent } from './clientes/form-datos-personales/form-datos-personales.component';
import { RecorridosComponent } from './recorridos/recorridos.component';
import { ControlEfectivoComponent } from './control-efectivo/control-efectivo.component';
import { DespachoRecorridoComponent } from './despacho-recorrido/despacho-recorrido.component';
import { SeleccionarClienteComponent } from './seleccionar-cliente/seleccionar-cliente.component';
import { ImprimirCargaCobranzasComponent } from './imprimir-carga-cobranzas/imprimir-carga-cobranzas.component';
import { CChicaAperturaComponent } from './c-chica-apertura/c-chica-apertura.component';
import { CChicaSolicitudFondoRendirComponent } from './c-chica-solicitud-fondo-rendir/c-chica-solicitud-fondo-rendir.component';
import { CChicaRendicionGastoComponent } from './c-chica-rendicion-gasto/c-chica-rendicion-gasto.component';
import { CChicaAgregarGastoComponent } from './c-chica-agregar-gasto/c-chica-agregar-gasto.component';
import { CChicaConsultaMovFondoComponent } from './c-chica-consulta-mov-fondo/c-chica-consulta-mov-fondo.component';
import { ControlEfectivoClienteComponent } from './control-efectivo-cliente/control-efectivo-cliente.component';
import { CotizacionesComponent } from './cotizaciones/cotizaciones.component';
import { MaquinasCensoComponent } from './maquinas-censo/maquinas-censo.component';
import { MaquinasReporteVendedorComponent } from './maquinas-reporte-vendedor/maquinas-reporte-vendedor.component';
import { MaquinasReporteMovimientoComponent } from './maquinas-reporte-movimiento/maquinas-reporte-movimiento.component';
import { MaquinasConsultaCensoComponent } from './maquinas-consulta-censo/maquinas-consulta-censo.component';
import { CentroCostoComponent } from './centro-costo/centro-costo.component';
import { CentroGastoComponent } from './centro-gasto/centro-gasto.component';
import { ClienteVendedorComponent } from './cliente-vendedor/cliente-vendedor.component';
import { RuteadorComponent } from './ruteador/ruteador.component';
import { RuteadorManualComponent } from './ruteador-manual/ruteador-manual.component';
import { RuteadorModalAsignarComponent } from './ruteador/modal-asignar/modal-asignar.component';
import { RuteadorModalAsignarAutomaticaComponent } from './ruteador/modal-asignar-automatica/modal-asignar-automatica.component';
import { ModalAddEditRutasComponent } from './ruteador/modal-add-edit-ruta/modal-add-edit-ruta.component';
import { ModalRutasCamionComponent } from './ruteador/modal-rutas-camion/modal-rutas-camion.component';
import { ModalRutasDivididasComponent } from './ruteador/modal-rutas-divididas/modal-rutas-divididas.component';
import { ModalClonarRecorridoComponent } from './ruteador/modal-clonar-recorrido/modal-clonar-recorrido.component';
import { RuteadorModalResultadoAsignacionComponent } from './ruteador/modal-resultado-asignacion/modal-resultado-asignacion.component';
import { ObjetivosComponent } from './objetivos/objetivos.component';
import { EmpresasComponent } from './empresas/empresas.component';
import { SucursalesComponent } from './sucursales/sucursales.component';
import { FormatosComponent } from './formatos/formatos.component';
import { FormDireccionesComponent } from './clientes/form-direcciones/form-direcciones.component';
import { VentasPanelComponent } from './reportes-ventas/ventas-panel/ventas-panel.component';
import { MercaderiaDevueltaComponent } from './mercaderia-devuelta/mercaderia-devuelta.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ReporteNcComponent } from './reporte-nc/reporte-nc.component';
import { UsuariosVendedorComponent } from './vendedor/usuarios-vendedor/usuarios-vendedor/usuarios-vendedor.component';
import { ModalEditProveedorComponent } from './clientes/modal-edit-proveedor/modal-edit-proveedor/modal-edit-proveedor.component';
import { SharedViewsModule } from './shared/shared-views.module';

import { CargaMasivaClientesComponent } from './clientes/carga-masiva-clientes/carga-masiva-clientes.component';
import { TableViewFoliosComponent } from './dashboards/table-view-folios/table-view-folios.component';
import { BloqueoVistaErrorsComponent } from './bloqueo-vista/bloqueo-vista-errors/bloqueo-vista-errors.component';

@NgModule({
  imports: [
    CommonModule,
    Ng9RutModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    SharedViewsModule,
    SharedModule,
    ScrollingModule,
    MatButtonModule,
    MatIconModule,
    InfiniteScrollModule,
    NgxSpinnerModule,
    AgmCoreModule.forRoot({
      // https://developers.google.com/maps/documentation/javascript/get-api-key?hl=en#key
      apiKey: '',
    }),
    ReportesModule,
    AccionesComercialesModule,
    InventarioModule,
    VentasModule,
    CtaCteClienteModule,
    CtaCteProveedoresModule,
    FinanzasModule,
    MaquinasModule,
    MantenedoresModule,
    ComprasModule,
    FacturacionMasivaModule,
    LiquidacionRecorridosModule,
    AnalisisEventosModule,
    ConfiguracionSistemaModule,
  ],
  declarations: [
    FooterComponent,
    BasicTableComponent,
    ModalsComponent,
    TypographyComponent,
    IconsComponent,
    Map1Component,
    StatsCardComponent,
    StatsCard2Component,
    Dashboard1Component,
    GridComponent,
    MediaObjectComponent,
    UtilitiesComponent,
    ImagesComponent,
    ColorsComponent,
    ShadowComponent,
    Profile1Component,
    HelpComponent,
    VendedorComponent,
    TerritorioComponent,
    BancoComponent,
    BodegaComponent,
    ZonaComponent,
    TipoclieComponent,
    RutaComponent,
    CondipagComponent,
    CobradorComponent,
    LoginComponent,
    NotificacionesComponent,
    TipoCuentaComponent,
    ClientesComponent,
    MantenedorClientesModalResumenComponent,
    MantenedorClientesModalDatosFinancierosComponent,
    MantenedorClientesModalDatosComercialesComponent,
    MantenedorClientesModalDireccionesComponent,
    MantenedorClientesModalDatosPersonalesComponent,
    FormDatosFinancierosComponent,
    FormDatosComercialesComponent,
    FormDatosPersonalesComponent,
    RecorridosComponent,
    ControlEfectivoComponent,
    DespachoRecorridoComponent,
    SeleccionarClienteComponent,
    ImprimirCargaCobranzasComponent,
    CChicaAperturaComponent,
    CChicaSolicitudFondoRendirComponent,
    CChicaRendicionGastoComponent,
    CChicaAgregarGastoComponent,
    CChicaConsultaMovFondoComponent,
    ControlEfectivoClienteComponent,
    CotizacionesComponent,
    MaquinasCensoComponent,
    MaquinasReporteVendedorComponent,
    MaquinasReporteMovimientoComponent,
    MaquinasConsultaCensoComponent,
    CentroCostoComponent,
    CentroGastoComponent,
    ClienteVendedorComponent,
    RuteadorComponent,
    RuteadorManualComponent,
    RuteadorModalAsignarComponent,
    RuteadorModalAsignarAutomaticaComponent,
    ModalAddEditRutasComponent,
    ModalRutasCamionComponent,
    ModalRutasDivididasComponent,
    ModalClonarRecorridoComponent,
    RuteadorModalResultadoAsignacionComponent,
    ObjetivosComponent,
    EmpresasComponent,
    SucursalesComponent,
    FormatosComponent,
    FormDireccionesComponent,
    VentasPanelComponent,
    MercaderiaDevueltaComponent,
    ReporteNcComponent,
    UsuariosVendedorComponent,
    ModalEditProveedorComponent,
    CargaMasivaClientesComponent,
    TableViewFoliosComponent,
    BloqueoVistaErrorsComponent,
    //ModalSeleccionarProductoComponent,
  ],
  exports: [
    FooterComponent,
    BasicTableComponent,
    ModalsComponent,
    TypographyComponent,
    IconsComponent,
    Map1Component,
    StatsCardComponent,
    StatsCard2Component,
    Dashboard1Component,
    GridComponent,
    MediaObjectComponent,
    UtilitiesComponent,
    ImagesComponent,
    ColorsComponent,
    ShadowComponent,
    LoginComponent,
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class ViewsModule { }
